import { useAuth } from '../../hooks/useAuth'
import Button from '../common/Button'

function Header() {
  const { user, logout } = useAuth()

  return (
    <header className="admin-header">
      <div className="header-content">
        <h1>Back-office</h1>

        <div className="header-actions">
          <span className="user-info">
            {user?.first_name} {user?.last_name} ({user?.role})
          </span>
          <Button variant="outline" size="small" onClick={logout}>
            Déconnexion
          </Button>
        </div>
      </div>
    </header>
  )
}

export default Header
